import { Accordion, BasicCollapsible, FlexBox, Typography } from "@vp/swan";
import React, { useContext } from "react";
import { BffDataContext } from "../../contexts/BffDataContextProvider";
import { DebugInfoSelectionsFields } from "./DebugInfoSelectionsFields";
import { DebugServiceLineItem } from "./DebugServiceLineItem";
import { DebugServiceWithToken } from "./DebugServiceWithToken";

const DebugServices = () => {
  const { debugData } = useContext(BffDataContext);
  const existingSelections: string[] = [];

  if (debugData && debugData.length > 0) {
    const collapsibles = debugData.map((data, index) => {
      const { selections, debugData: debugInfo } = data;

      const serializedSelections = serializeSelections(selections);

      if (existingSelections.includes(serializedSelections)) {
        return <></>;
      }

      existingSelections.push(serializedSelections);
      const title =
        Object.entries(selections)
          .map(([property, option]: [string, string]) => {
            return `${property}: ${option}`;
          })
          .join("; ")
          ?.substring(0, 100) || "No selection";

      return (
        <BasicCollapsible key={index} collapsibleId={`collapsible-${index}`} heading={title}>
          <DebugInfoSelectionsFields selections={selections} />
          <FlexBox flexDirection="column" flexWrap="wrap">
            {debugInfo?.urls?.map(url => {
              if (url.indexOf("https://ranch-cdn.products.cimpress.io") >= 0) {
                return <DebugServiceWithToken key={url} url={url} />;
              } else {
                return <DebugServiceLineItem key={url} url={url} />;
              }
            })}
          </FlexBox>
        </BasicCollapsible>
      );
    });

    return (
      <FlexBox flexDirection="column" style={{ flexGrow: 2 }}>
        <Typography mb={"2"} mr={"4"} fontWeight="bold">
          Debug BFF Service
        </Typography>
        <Accordion fullBleed pl={"7"}>
          {collapsibles}
        </Accordion>
      </FlexBox>
    );
  }

  return <></>;
};

const serializeSelections = (selections: Record<string, string>) => {
  return Object.keys(selections)
    .sort()
    .map(key => `${key}:${selections[`${key}`]}`)
    .join(",");
};

export default DebugServices;
